import { Typography } from '@mui/material'

export const ErrParagragh = ({ errMsg }) => {
  return (
    <Typography variant='subtitle2' component="span" style={{ fontSize: '0.8rem', textAlign: 'right', width: '100%', marginTop: '5px', color: '#d32f2f', paddingRight: '16px'}}>
        {errMsg}
    </Typography>
  )
}
